import { render, staticRenderFns } from "./TemplateMarketPreviewItem.vue?vue&type=template&id=58c046e6&scoped=true"
import script from "./TemplateMarketPreviewItem.vue?vue&type=script&lang=js"
export * from "./TemplateMarketPreviewItem.vue?vue&type=script&lang=js"
import style0 from "./TemplateMarketPreviewItem.vue?vue&type=style&index=0&id=58c046e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c046e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c046e6')) {
      api.createRecord('58c046e6', component.options)
    } else {
      api.reload('58c046e6', component.options)
    }
    module.hot.accept("./TemplateMarketPreviewItem.vue?vue&type=template&id=58c046e6&scoped=true", function () {
      api.rerender('58c046e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/appTemplateMarket/component/TemplateMarketPreviewItem.vue"
export default component.exports